import React from 'react';

// Assuming you have a MarkdownRenderer component like the one from previous examples.
// Adjust the import path as necessary.
import MarkdownRenderer from '../MarkdownRenderer';

const OutputRenderer = ({ content }) => {
  // If content is null, undefined, or an empty string, render nothing.
  if (!content) {
    return null;
  }

  try {
    const parsed = JSON.parse(content);
    // We only want to pretty-print structured JSON (objects or arrays).
    // This avoids formatting simple JSON strings like "hello" as code.
    if (parsed && typeof parsed === 'object') {
      return (
        <pre className="whitespace-pre-wrap break-all rounded-md bg-zinc-900 p-3 text-sm">
          {JSON.stringify(parsed, null, 2)}
        </pre>
      );
    }
  } catch (e) {
    // This is expected if the content is not a valid JSON string.
    // We will fall through and render it as Markdown.
  }

  // If parsing fails or if the content is not a structured object,
  // render it using the Markdown renderer.
  // We use String() to safely handle non-string primitives like numbers or booleans.
  return <MarkdownRenderer markdown={String(content)} />;
};

export default OutputRenderer;
